export default "__VITE_ASSET__np1fZ3jC__"